/**************************************************
 * Nombre:       Formulario_Estado.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    FlagOutlined,
    Mail,
    SchoolOutlined,
    SmartphoneOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPEDIDOS} from "../../Constantes";
import IngresoTextoLista from "../../Modulo_formularios/Componentes/IngresoTextoLista";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {iniciarChatWass} from "../../Modulo_ChatWass/Funciones/iniciarChatWass";
import IngresoRating from "../../Modulo_formularios/Componentes/IngresoRating";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";

const Formulario_Estado = ({...props}) => {
    const cData = useContext(usuarioContext)
    const [estados, setEstados] = useState([])


    useEffect(() => {
        if (cData.configCrm && cData.configCrm.length > 0) {
            setEstados(cData.configCrm[0].columnas)
        }
    },[cData])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={estados}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoRating {...props} dato={'persepcion'}  nombre={'Persepcion'} size={'medium'} />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Estado